<span *ngIf="!!menuItem.icon" class="se-menu-item-icon">
  <se-icon name="{{ menuItem.icon }}" size="500"></se-icon>
</span>
<span [ngClass]="{'se-menu-item--has-subtext': !!menuItem.subText}">
  <p class="se-menu-item__text">{{ menuItem.text }}</p>
  <p class="se-menu-item__sub-text">{{ menuItem.subText }}</p>
</span>
